import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import Feature1 from '../../../images/icons/Feature1.png';
import Feature2 from '../../../images/icons/Feature2.png';
import Feature3 from '../../../images/icons/Feature3.png';
import Feature4 from '../../../images/icons/Feature4.png';

// ES6 class-style
class LessonFeatures extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" id="LessonFeatures">
		<div className="container">			
			<div className="row">
            <span>{this.rb("custom.label.txt.2")}</span>
			    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature1} alt="student listening to video lecture" />
                    <h3>Video lessons</h3>
                    <p>10,000+ animated lessons with interesting real-life contexts that explain the how and why of every concept</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature2} alt="Bite-sized quizzes" />
                    <h3>Bite-sized quizzes</h3>
                    <p>Interactive tasks that make learning fun and immediate feedback to help you build confidence</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature3} alt=" Diagnostic test report" />
                    <h3>Customised Study Plan</h3>
                    <p>Diagnostics Tests, recommended lessons and targeted practice, from a bank of 1,00,000+ problems</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature4} alt="Granular report card" />
                    <h3>Granular report card</h3>
                    <p>Topic wise grades to know precisely which problems to focus on to improve your overall performance</p>
                </div>
            </div>
		</div>
	</div>
  	);
  }
}

export default LessonFeatures;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/LessonFeatures.js